import type { Formatter } from '../../../core/types/formatter.js';

/**
 * Tooltip-friendly stringifier for flame values. When a `Formatter` is provided,
 * the raw value is coerced to a number (missing values become `0`) and handed
 * to it. Without a formatter, the value is stringified (missing values become
 * an empty string) — matching the tooltip conventions used by the other charts.
 */
export function formatFlameValue(
  value: unknown,
  formatter?: Formatter,
): string {
  if (formatter) {
    return formatter(Number(value ?? 0));
  }
  return String(value ?? '');
}
